
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Use Unit with Plaid Auth to send and receive payments"
};
export const partnerProps = {
  partner: 'Unit',
  clientLibrary: 'unit',
  subtitle: metadata.description,
  registrationUrl: 'https://www.unit.co/book-demo',
  apiUrl: 'https://docs.unit.co/',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Unit have partnered to help Unit clients instantly authenticate external bank accounts and subsequently interact with them as counterparties within Unit. The integration helps Unit clients easily fund accounts on Unit, pull funds from counterparties, or push funds to counterparties without requiring them to handle their account details. `}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthIdentityInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
